import { getPredicateMetric } from '../core/alerts';
import { getConverters, getMyUnit, getToDefaultUnitConverters } from '../core/units';
import * as methods from '../methods';
import { Resource } from '../Resource';
import { isThresholded } from './alerts.types';
const rootPath = 'alerts';
const parse = ({ alert, origin, preferredUnits }) => {
    const getUnit = (metric) => getMyUnit(metric, preferredUnits);
    const newPredicates = {};
    Object.entries(alert.predicates).forEach(([key, predicate]) => {
        const castedKey = key;
        let newPdc = predicate;
        const { params } = newPdc;
        const metric = getPredicateMetric(newPdc);
        const unit = getUnit(metric);
        const converter = origin === 'from' ? getConverters(metric) : getToDefaultUnitConverters(metric);
        if (isThresholded(params)) {
            newPdc = {
                ...newPdc,
                params: {
                    ...params,
                    threshold: converter(params.threshold, castedKey === 'cumul-gt-LW_D' ? 'hours' : unit)
                }
            };
        }
        newPredicates[castedKey] = newPdc;
    });
    return { ...alert, predicates: newPredicates };
};
const fromRaw = {
    get: (alert, preferredUnits) => parse({ alert, origin: 'from', preferredUnits }),
    getMany: (alerts, preferredUnits) => alerts.map((alert) => parse({ alert, origin: 'from', preferredUnits }))
};
const toRaw = {
    create: (payload, preferredUnits) => parse({ alert: payload, origin: 'to', preferredUnits })
};
export default Resource((requesterBuilder, { getCtx }) => {
    const host = getCtx().hosts.ts;
    const getMany = (preferredUnits, query) => requesterBuilder({
        path: rootPath,
        requestCtx: {
            transform: (alerts) => fromRaw.getMany(alerts, preferredUnits),
            host,
            params: { query }
        }
    });
    const get = (preferredUnits) => methods.get({
        host,
        requesterBuilder,
        rootPath,
        fromRaw: (alert) => fromRaw.get(alert, preferredUnits)
    });
    return {
        get,
        getMany,
        create: (preferredUnits) => methods.create({
            host,
            requesterBuilder,
            rootPath,
            fromRaw: (alert) => fromRaw.get(alert, preferredUnits),
            toRaw: (payload) => toRaw.create(payload, preferredUnits),
            buildKeysToInvalidate: () => [getMany().invalidationKey]
        }),
        delete: methods.deletion({
            host,
            requesterBuilder,
            rootPath
        }),
        replace: (preferredUnits) => methods.update({
            host,
            requesterBuilder,
            rootPath,
            fromRaw: (alert) => fromRaw.get(alert, preferredUnits),
            toRaw: (payload) => toRaw.create(payload, preferredUnits)
        }),
        update: (preferredUnits) => methods.update({
            host,
            method: 'PATCH',
            requesterBuilder,
            rootPath,
            fromRaw: (alert) => fromRaw.get(alert, preferredUnits),
            toRaw: (x) => x,
            buildKeysToInvalidate: (id) => [
                getMany().invalidationKey,
                get(preferredUnits)(id).invalidationKey
            ]
        })
    };
});
